var map = {
	"./edrr/lang": [
		"mrCD",
		3
	],
	"./edrr/lang.vue": [
		"mrCD",
		3
	],
	"./edrr/main": [
		"xfA4",
		0
	],
	"./edrr/main.vue": [
		"xfA4",
		0
	],
	"./edrr/main.vue.b": [
		"GUUz",
		10
	],
	"./edrr/main.vue.b2": [
		"M9HL",
		9
	],
	"./edrr/tool": [
		"AVXV",
		1
	],
	"./edrr/tool.vue": [
		"AVXV",
		1
	],
	"./home": [
		"vkyI",
		8
	],
	"./home.vue": [
		"vkyI",
		8
	],
	"./welcome": [
		"V+V2",
		2
	],
	"./welcome.vue": [
		"V+V2",
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5BXs";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*$
// module id = 5BXs
// module chunks = 12